import { makeStyles } from '@material-ui/core';
import { get } from 'lodash';
import React from 'react';
import ActionCell from './ActionCell';
import CheckboxCell from './CheckboxCell';
import DateInputCell from './DateInputCell';
import DropDownCell from './DropDownCell';
import FilesDataCell from './FilesDataCell';
import RadioInputCell from './RadioInputCell';
import ReadOnlyCell from './ReadOnlyCell';
import TextInputCell from './TextInputCell';
import SearchFieldCell from './SearchFieldCell';

const useStyles = makeStyles(() => ({
  cellContainer: {
    padding: '2px 30px 2px 30px',
    marginTop: '10px',
    marginBottom: '10px',
    display: 'flex',
    alignItems: 'center',
  },
}));

const DataCell = (props) => {
  const classes = useStyles();
  // cellComponentRenderer is responsible for deciding what component to render in cell based on columnContentType
  const cellComponentRenderer = {
    0: ReadOnlyCell,
    1: DropDownCell,
    2: TextInputCell,
    3: DateInputCell,
    4: ActionCell,
    5: RadioInputCell,
    6: FilesDataCell,
    7: CheckboxCell,
    8: SearchFieldCell,
  };
  const defaultCell = get(cellComponentRenderer, 0);
  const columnType = get(props.column, 'columnContentType.columnType');
  const CellComponent = get(cellComponentRenderer, columnType, defaultCell);

  return (
    <div
      style={{
        // borderLeft: props.index > 0 ? '1px solid #cccccc' : 'none',
        minHeight: props.cellHeight ? props.cellHeight - 22 : undefined,
      }}
      className={classes.cellContainer}
    >
      <CellComponent {...props} />
    </div>
  );
};

export default DataCell;
